module.exports = __webpack_public_path__ + "static/media/MamaPayStyleGuide.35f40140.pdf";